export const SALE_MINUTES_PERCENT_LABEL = 80;
export const SALE_SUBSCRIPTION_PERCENT_LABEL = 36;
